import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { localizedStrings } from '@core/strings'
import { ObservationStatus } from '@core/entities/observation/types'
import { IObservationTargetResult } from './IObservationTargetResult'

export class ObservationTargetResult extends Entity<IObservationTargetResult> {
  id: number
  organisationId: number
  projectId: number
  status: ObservationStatus
  transcript: string
  title?: string

  public static new(
    payload: IObservationTargetResult,
  ): ObservationTargetResult {
    return plainToInstance(ObservationTargetResult, payload)
  }

  // Untitled observations fall back to the generic label rather than rendering blank
  public getTitleText(): string {
    return this.title?.trim() || localizedStrings.observation
  }
}
